module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE STORY DEVOTIONAL")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctp",
    attrs: {
      "id": "p0016-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#fn_9",
      "id": "sn_9"
    }
  }, [_vm._v("DAY 9")])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fn_9"
    }
  }, [_vm._v("KNOWING OUR NEEDS—AND MEETING THEM")])]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('span', [_c('i', [_vm._v("The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" God said, “It is not good for the man to be alone. I will make a helper suitable for him.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_c('span', [_c('i', [_vm._v("So the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" God caused the man to fall into a deep sleep; and he took one of the man’s ribs. Then the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" God made a woman from the rib.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("GENESIS")]), _vm._v(" 2:18, 21–22")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0016-04-5"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("D")]), _vm._v("o you have a friend who knows what you need without your having to say a word? What a blessing to be known and loved like that! And God loved Adam that way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At God’s instruction, Adam had just done a basic inventory of every animal the Lord had created and given each a name. The last of the menagerie passed by, “but for Adam no suitable helper was found” (Genesis 2:20). Without Adam even voicing the need or desire, and perhaps without Adam even recognizing it on his own, God knew exactly what Adam needed. Our Creator-God was not finished yet!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God outdid himself in crafting a “helper suitable” for Adam: she took his breath away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("God knew Adam’s need for companionship and gave him a gift beyond his imagining. Likewise, God knows your needs, and he will meet them—often with a blessing beyond your imagining!")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("THE LORD KNOWS OUR NEEDS AND GENEROUSLY MEETS THEM.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b72510a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter12.vue
// module id = 96
// module chunks = 0